/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Calendar } from '../../models/calendar';
import { CalendarNew } from '../../models/calendar-new';

export interface CreateCalendar$Params {
      body: CalendarNew
}

export function createCalendar(http: HttpClient, rootUrl: string, params: CreateCalendar$Params, context?: HttpContext): Observable<StrictHttpResponse<Calendar>> {
  const rb = new RequestBuilder(rootUrl, createCalendar.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Calendar>;
    })
  );
}

createCalendar.PATH = '/api/v1/calendars';
